import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=d4cfc83c&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=d4cfc83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cfc83c",
  null
  
)

export default component.exports